'use strict';

module Patersons {

    export interface MarketChartScope extends ng.IScope {
        events: Patersons.MarketChartCtrl;
        isLoading: boolean;
        isCompare: boolean;
    }


    export class MarketChartCtrl extends AnalysisBaseCtrl {
        scope: Patersons.MarketChartScope;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;

            this.load();
        }

        load() {
            this.log.info('market chartCtrl loading...')
            var tickers = [];
            var compareTickers = []
            var mainTicker = '';
            if (this.state.params['secIds'] != undefined && this.state.params['secIds'] != null) {
                tickers = this.state.params['secIds'].split('|');
                if (tickers.length > 1) {
                    compareTickers = tickers.slice(1);
                }
                this.scope.isCompare = true;
                mainTicker = tickers[0];
            }

            rootMorningstarPromise().then(function (morningstarPromise) {
                console.log('initializing component');
                if(mainTicker){
                    loaderConfig.configuration.overrides.components.advanceChart_compare.settings.mainTicker = mainTicker;
                    loaderConfig.configuration.overrides.components.advanceChart_compare.settings.compareTickers = compareTickers;
                    initComponent('component-container', 'chart-container', 'markets-components-svgchart', 'advanceChart_compare').then(function () {
                        console.log("done loading advance chart");
                    });
                }else{
                    initComponent('component-container', 'chart-container', 'markets-components-svgchart', 'advanceChart').then(function () {
                        console.log("done loading advance chart");
                    });
                }

            });
        }
    }
}
